<script setup>
const props = defineProps({
  list: {
    type: Array,
    default() {
      return [];
    },
  },
  modelValue: {
    type: [String, Number, Array],
    default() {
      return '';
    },
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <UiSelect
    :list="list"
    :model-value="modelValue"
    class="ui-select-pagination"
    prepend-icon="bars"
    width="70"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template v-slot:options>
      <ElOption
        v-for="item in list"
        :key="item"
        :label="item"
        :value="item"
      >
        <span>{{ item }}</span>
      </ElOption>
    </template>
  </UiSelect>
</template>

<style lang="scss">
.ui-select-pagination {
  margin-right: 6px;

  .el-select__wrapper {
    padding-left: 7px;
    padding-right: 5px;
  }

  .el-select__placeholder {
    text-align: center;
  }

  .ui-select__prepend-icon {
    margin-right: -3px;
  }
}
</style>